import { ComponentProps, MouseEvent, ReactNode } from 'react';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpTooltip } from 'new-components/DLS/OpTooltip/OpTooltip';

interface RowButtonProps extends ComponentProps<typeof OpButton> {
  onClick: (e?: MouseEvent<HTMLElement>) => void;
  testId?: string;
  gtm?: string;
  tooltip?: ReactNode;
}

export const RowButton = ({
  onClick,
  icon,
  disabled,
  tooltip,
  testId = 'row-button',
  gtm,
  ...buttonProps
}: RowButtonProps) => {
  return (
    <OpTooltip title={tooltip}>
      <OpButton
        disabled={disabled}
        icon={icon}
        size="small"
        shape="circle"
        type="text"
        testId={testId}
        gtm={gtm}
        {...buttonProps}
        {...(onClick && {
          onClick: (e) => {
            e.stopPropagation(); // Prevents onRowClick from being called when clicking the button
            onClick(e);
          },
        })}
      />
    </OpTooltip>
  );
};
